import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const MARKERS = false

let mm

const createCompareTimeline = (section, isDesktop) => {
	const scene = section.querySelector('[data-comparison-compare]')
	const [intro, comparison] = section.querySelectorAll('[data-comparison-text]')
	const heatmaps = section.querySelectorAll('[data-comparison-heatmap]')
	const captions = section.querySelectorAll('[data-comparison-caption]')

	if (!scene) return

	const tl = gsap.timeline({
		defaults: { duration: 1, ease: 'power1.inOut' },
		scrollTrigger: {
			id: 'comparison',
			trigger: scene,
			start: 'center center',
			end: '+=150%',
			pin: true,
			scrub: 1.2,
			invalidateOnRefresh: true,
			markers: MARKERS
		}
	})

	if (intro && comparison) {
		if (isDesktop) {
			tl.to(intro, { y: () => window.innerHeight * -0.35, autoAlpha: 0 }, 0)
			tl.fromTo(comparison, { y: () => window.innerHeight * 0.35, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, 0)
		} else {
			tl.to(intro, { y: -20, autoAlpha: 0, duration: 0.5 }, 0)
			tl.fromTo(comparison, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5 }, 0.5)
		}
	}

	// Desktop runs the reveal alongside the text; mobile waits for the text swap to finish
	if (heatmaps.length) {
		tl.fromTo(heatmaps, { clipPath: 'inset(0 0 0 100%)' }, { clipPath: 'inset(0 0 0 50%)', duration: 1.4 }, isDesktop ? 0.25 : '>')
	}

	if (captions.length) {
		tl.fromTo(captions, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4 })
	}

	tl.to({}, { duration: 0.3 })
}

const createDisposalTimeline = (section) => {
	const scene = section.querySelector('[data-comparison-disposal]')
	const body = section.querySelector('[data-comparison-body]')
	const items = section.querySelectorAll('[data-comparison-disposal-item]')

	if (!scene) return

	if (body) {
		gsap.fromTo(body, { autoAlpha: 0 }, {
			autoAlpha: 1,
			ease: 'none',
			scrollTrigger: {
				id: 'disposal-text',
				trigger: scene,
				start: 'top bottom',
				end: 'center center',
				scrub: 1.2,
				markers: MARKERS
			}
		})
	}

	const tl = gsap.timeline({
		scrollTrigger: {
			id: 'disposal',
			trigger: scene,
			start: 'center center',
			end: '+=120%',
			pin: true,
			scrub: 1.2,
			invalidateOnRefresh: true,
			markers: MARKERS
		}
	})

	items.forEach((item, index) => {
		const media = item.querySelector('[data-comparison-disposal-media]')
		const label = item.querySelector('[data-comparison-label]')

		tl.fromTo(media, { scale: 0.6, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, duration: 1, ease: 'power2.out' }, index ? '>-0.3' : 0)
		tl.fromTo(label, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, ease: 'power1.out' }, '<0.4')
	})

	tl.to({}, { duration: 0.3 })
}

export const initComparison = () => {
	mm?.revert()

	const sections = document.querySelectorAll('[data-comparison]')

	if (sections.length === 0) return

	mm = gsap.matchMedia()

	sections.forEach((section) => {
		mm.add({
			isDesktop: '(min-width: 1025px)',
			isMobile: '(max-width: 1024px)',
			reduceMotion: '(prefers-reduced-motion: reduce)'
		}, (context) => {
			const { isDesktop, reduceMotion } = context.conditions

			if (reduceMotion) return

			section.dataset.comparisonAnimated = ''

			createCompareTimeline(section, isDesktop)
			createDisposalTimeline(section)

			return () => {
				delete section.dataset.comparisonAnimated
			}
		})
	})
}
